export class BaseInvoiceThemeModel {
  public id = null;
  public themeColor = '';
  public footerBackgroundColor = '';
}
